/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{animateMotionValue as o}from"./motion-value.js";import{motionValue as t}from"../../value/index.js";import{isMotionValue as i}from"../../value/utils/is-motion-value.js";function r(r,m,n){const a=i(r)?r:t(r);return a.start(o("",a,m,n)),a.animation}export{r as animateSingleValue};
//# sourceMappingURL=single-value.js.map
